import orders from "../../api/orders";
import { formatISO } from "date-fns";
import router from "../../router";
import axios from "axios";

// initial state
const state = () => ({
  loading: {
    orders: false,
    order: false,
  },
  generating: false,
  all: [],
  total: undefined,
  current: undefined,
  labels: {
    draft: "Brouillon",
    "level-1": "Chef technique, resp. service ou directeur de centre",
    "level-2": "Doyen, respondable de centre ou de service",
    "level-3": "Responsable centre de coût",
    "level-4": "Responsable service finance",
    "level-5": "Direction et responsable service finance",
    accepted: "Validé",
    rejected: "Refusé",
  },
  editedIndex: -1,
  editedItem: {
    description: "",
    quantity: "",
    serial: "",
  },
  defaultItem: {
    description: "",
    quantity: "",
    serial: "",
  },
  dialog: false,
  offerUploading: false,
  documentUploading: false,
});

// getters if needed

// actions
const actions = {
  async loadOrders({ dispatch, commit }) {
    commit("SET_LOADING", ["orders", true]);
    try {
      commit("ADD_ORDERS", await orders.getOrders());
      commit("SET_LOADING", ["orders", false]);
    } catch (error) {
      dispatch("snackbar/showError", error.message, { root: true });
      commit("SET_LOADING", ["orders", false]);
    }
  },
  async loadOrder({ dispatch, commit }, _id) {
    commit("SET_LOADING", ["order", true]);
    try {
      const { data: order } = await orders.getOrder(_id);
      commit("SET_ORDER", order);
      commit("SET_LOADING", ["order", false]);
    } catch (error) {
      dispatch("snackbar/showError", error.message, { root: true });
      commit("SET_LOADING", ["order", false]);
    }
  },
  async createOrder({ dispatch, commit }, order) {
    commit("SET_GENERATING", true);
    try {
      const { data: created } = await orders.createOrder(order);
      dispatch("addOrder", created);
      router.push(`/orders/${created._id}`);
      commit("SET_GENERATING", false);
    } catch (error) {
      dispatch("snackbar/showError", error.message, { root: true });
      commit("SET_GENERATING", false);
    }
  },
  async updateOrder({ dispatch, commit }, order) {
    commit("SET_GENERATING", true);
    try {
      const { data: updated } = await orders.updateOrder(order);
      dispatch("updateOrders", updated);
      commit("SET_GENERATING", false);
    } catch (error) {
      dispatch("snackbar/showError", error.message, { root: true });
      commit("SET_GENERATING", false);
    }
  },
  async uploadOffer({ commit, dispatch }, file) {
    if (file) {
      commit("SET_OFFER_UPLOADING", true);
      try {
        const formData = new FormData();
        formData.append("file", file);

        const { data } = await axios({
          method: "post",
          url: `${process.env.VUE_APP_API_URI}/upload`,
          data: formData,
          headers: {
            "content-Type": "multipart/form-data",
          },
        });
        commit("SET_OFFER", data.filename);
        commit("SET_OFFER_UPLOADING", false);
      } catch (e) {
        dispatch("snackbar/showError", e.message, { root: true });
        commit("SET_OFFER_UPLOADING", false);
      }
    }
  },
  async uploadDocument({ commit, dispatch }, file) {
    if (file) {
       commit("SET_DOCUMENT_UPLOADING", true);
      try {
        const formData = new FormData();
        formData.append("file", file);
        const { data } = await axios({
          method: "post",
          url: `${process.env.VUE_APP_API_URI}/upload`,
          data: formData,
          headers: {
            "content-Type": "multipart/form-data",
          },
        });
        commit("SET_DOCUMENT", data.filename);
        commit("SET_DOCUMENT_UPLOADING", false);
      } catch (e) {
        dispatch("snackbar/showError", e.message, { root: true });
        commit("SET_DOCUMENT_UPLOADING", false);
      }
    }
  },
  updateOrders({ commit }, order) {
    commit("SET_ORDERS", order);
    commit("SET_ORDER", order);
  },
  addOrder({ commit }, order) {
    commit("ADD_ORDER", order);
    commit("SET_ORDER", order);
  },
  updateItem({ commit }, { index, item }) {
    commit("SET_ITEM", [index, item]);
  },
  addItem({ commit }, item) {
    commit("ADD_ITEM", item);
  },
  deleteItem({ commit }, index) {
    commit("DELETE_ITEM", index);
  },
  editItem({ commit }, item) {
    commit("SET_EDITED_ITEM", item);
  },
  initOrder({ commit }) {
    commit("SET_ORDER", {
      supplier: "",
      delivery: "HEIG-VD\nRoute de Cheseaux 1\nCH-1400 Yverdon-les-Bains",
      value: "",
      recipient: "",
      year: new Date().getFullYear().toString(),
      account: "",
      costCenter: "",
      comments: "",
      items: [],
      currency: "CHF",
      buyer: "",
      offer: "",
      document: "",
      clientNumber: "",
      projectNumber: "",
      offerRef: "",
      offerRefDate: "",
      creatorTla: "",
      supplierEmail: "",
      poDate: formatISO(new Date()),
    });
  },
  updateCurrent({ commit }, { fieldname, value }) {
    commit("SET_CURRENT", [fieldname, value]);
  },
  openDialog({ commit }) {
    commit("SET_DIALOG_OPEN", true);
  },
  closeDialog({ commit }) {
    commit("SET_DIALOG_OPEN", false);
    commit("RESET_EDITED_ITEM");
  },
  updateCurrentItem({ commit }, { fieldname, value }) {
    commit("SET_CURRENT_ITEM", [fieldname, value]);
  },
};

// mutations
const mutations = {
  ADD_ORDERS(state, { data }) {
    state.all = data.docs;
    state.total = data.totalDocs;
  },
  ADD_ORDER(state, order) {
    state.all.push(order);
  },
  SET_ORDERS(state, order) {
    Object.assign(
      state.all.find((o) => o._id === order._id),
      order
    );
  },
  SET_ORDER(state, order) {
    state.current = order;
  },
  SET_LOADING(state, [type, loading]) {
    state.loading[type] = loading;
  },
  SET_GENERATING(state, generating) {
    state.generating = generating;
  },
  SET_CURRENT(state, [fieldname, value]) {
    state.current[fieldname] = value;
  },
  SET_CURRENT_ITEM(state, [fieldname, value]) {
    state.editedItem[fieldname] = value;
  },
  SET_ITEM(state, [index, item]) {
    Object.assign(state.current.items[index], item);
  },
  ADD_ITEM(state, item) {
    state.current.items.push(item);
  },
  DELETE_ITEM(state, index) {
    console.log(index);
    state.current.items.splice(index, 1);
  },
  SET_EDITED_ITEM(state, item) {
    state.editedIndex = state.current.items.indexOf(item);
    state.editedItem = Object.assign({}, item);
    state.dialog = true;
  },
  SET_DIALOG_OPEN(state, open) {
    state.dialog = open;
  },
  RESET_EDITED_ITEM(state) {
    state.editedItem = Object.assign({}, state.defaultItem);
    state.editedIndex = -1;
  },
  SET_OFFER(state, offer) {
    state.current.offer = offer;
  },
  SET_OFFER_UPLOADING(state, uploading) {
    state.offerUploading = uploading;
  },
  SET_DOCUMENT(state, document) {
    state.current.document = document;
  },
  SET_DOCUMENT_UPLOADING(state, uploading) {
    state.documentUploading = uploading;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
